// Copyright 2022, Imprivata, Inc.  All rights reserved. 
import { Typography } from 'antd';
import { useTranslation } from "react-i18next";
import type React from 'react';
import { useGetTenantQuery } from '../../api/hooks';
import './CustomerNameComponent.less';
import ImprivataLogo from '../../assets/svg/imprivata-logo.svg';
const CustomerNameComponent: React.FC = () => {
  const { t } = useTranslation();
  const { tenantName, logoUrl } = useGetTenantQuery();
  return (
    <div className="container-customer-name">
      {logoUrl ? (
        <img src={logoUrl} alt="Hospital Logo" className="hospital-logo" />
      ) : (
        <Typography.Title level={3} className="header-customer-name text-center" data-testid="header-customer-name">
          {tenantName}
        </Typography.Title>
      )}
      <Typography.Title level={5} className="header-powered-by text-center" data-testid="header-powered-by">
        {t("customerName.account-device-handoff-title")}
        <img src={ImprivataLogo} alt="Imprivata Logo" className="imprivata-logo" />
      </Typography.Title>
    </div>
  );
};
export default CustomerNameComponent;
